export default __webpack_public_path__ + "static/media/oedusantana_kitlancamento.84e65784.svg";